import { css } from '@emotion/react';

import { Colors, Link, Typography } from '@zapier/design-system';
import { urls, useSize } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';

const textStyle = css`
  ${Typography.Body1}
  color: ${Colors.GrayWarm10};
  text-align: center;
`;

const rootStyle = css`
  display: grid;
  gap: 20px;
  padding: 40px 0;
`;

export function LockedAccountPage() {
  const size = useSize();
  const t = useTranslations('locked-account');

  function ResetLink(chunks: React.ReactNode) {
    return <Link href={urls.FORGOT_PASSWORD_URL}>{chunks}</Link>;
  }

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={'Your account is locked'}
      titlePosition={'right'}
    >
      <section css={rootStyle}>
        <p css={[textStyle]}>{t.rich('description', { link: ResetLink })}</p>
      </section>
    </AuthLayout>
  );
}
